import { render, staticRenderFns } from "./BpCostOfGoodsSoldTable.vue?vue&type=template&id=f099aae6"
import script from "./BpCostOfGoodsSoldTable.vue?vue&type=script&lang=ts"
export * from "./BpCostOfGoodsSoldTable.vue?vue&type=script&lang=ts"
import style0 from "./BpCostOfGoodsSoldTable.vue?vue&type=style&index=0&id=f099aae6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports